import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useGeneralSoContext } from 'src/common/context';
import { GetTermsAndConditionsQuery } from '../types/types';

const GET_TERMS_AND_CONDITIONS_QUERY = gql(`
 query GetTermsAndConditions($id: String!) {
  getTermsAndConditions(id: $id) {
    brandName
    brandCode
    documents {
      fileId
    fileName
    }
  }
}
`);

export function useGetTermsAndConditions() {
  const { offerId } = useGeneralSoContext();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  const { data, loading, error, refetch } = useQuery<GetTermsAndConditionsQuery>(GET_TERMS_AND_CONDITIONS_QUERY, {
    variables: { id: offerId },
    skip: !offerId,
    fetchPolicy: 'network-only'
  });

  const isLoading = !isInitialized || loading;

  return {
    termsAndConditions: offerId ? data?.getTermsAndConditions : undefined,
    loading: isLoading,
    error,
    refetch,
    offerId
  };
}
